import { render } from "./ThatMadeForYou.vue?vue&type=template&id=ab4fe818&ts=true"
import script from "./ThatMadeForYou.vue?vue&type=script&lang=ts"
export * from "./ThatMadeForYou.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__